import { useMemo } from "react";
import type { RadioFilterParam } from "@/react/components/shared/Filter/FilterTypes/RadioFilterV2";
import { RadioFilterV2 as RadioFilter } from "@/react/components/shared/Filter/FilterTypes/RadioFilterV2";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { Filter } from "@circle-react-shared/FilterV3";
import { FilterChip } from "../../shared/FilterV3/FilterChipV2";
import { useFilterProvider } from "../FilterProvider";
import type { RadioFilterConfiguration } from "../types";

interface RadioFilterInputProps {
  configuration: RadioFilterConfiguration;
}

// This component is not used in the FilterKit yet so implementation might not be correct
export const RadioFilterInput = ({ configuration }: RadioFilterInputProps) => {
  const { setFilter, filterParamForKey, clearFilterByKey } =
    useFilterProvider();

  const param = useMemo((): RadioFilterParam => {
    const existingFilter = filterParamForKey(configuration.key) as
      | RadioFilterParam
      | undefined;

    return {
      id: configuration.key,
      key: configuration.key,
      value: (existingFilter?.value as string) ?? "",
    };
  }, [filterParamForKey, configuration.key]);

  const options = configuration.payload.options.map(opt => ({
    label: opt.key,
    value: String(opt.value),
  }));

  const handleApply = (value: BaseFilter | null) => {
    if (value === null) {
      clearFilterByKey(configuration.key);
    } else {
      setFilter(configuration.key, {
        ...value,
        search_key: configuration.search_key,
      });
    }
  };

  return (
    <Filter onApply={handleApply}>
      <FilterChip renderSelectedValue={() => param.value}>
        {configuration.label}
      </FilterChip>
      <Filter.Popover title={configuration.label}>
        <RadioFilter
          options={options}
          param={param}
          legend={configuration.label}
        />
      </Filter.Popover>
    </Filter>
  );
};
